import * as Sentry from "@sentry/nextjs";

// 진단용 데이터만 반환한다. URL 원문·토큰·결제 키·임의 쿼리 값은 보관하지 않는다.
export function describeTossCallback(params: URLSearchParams) {
  const value = params.get("amount");
  const amount = value !== null && /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) && Number(value) > 0
    ? Number(value) : null;
  return {
    amountState: value === null ? "missing" : value === "" ? "empty" : amount === null ? "invalid" : "valid",
    amount,
    hasOrderId: Boolean(params.get("orderId")),
    hasPaymentKey: Boolean(params.get("paymentKey")),
    hasToken: Boolean(params.get("token")),
    duplicateAmount: params.getAll("amount").length > 1,
  };
}

export function callbackDiagnosticOrderId(params: URLSearchParams) {
  const value = params.get("diagnosticOrderId");
  return value && /^order_[a-f0-9]{32}$/.test(value) ? value : null;
}

export function captureTossDiagnostic(stage: string, extra: Record<string, unknown>) {
  try {
    Sentry.captureMessage(`Toss payment diagnostic: ${stage}`, (scope) => {
      scope.setLevel("info");
      scope.setTags({ api: "toss-diagnostic", stage });
      scope.setExtras(extra);
      // SDK가 자동 첨부하는 URL·본문·쿠키·사용자·breadcrumb도 수집하지 않는다.
      scope.addEventProcessor((event) => ({
        ...event, request: undefined, user: undefined, breadcrumbs: [],
        tags: { api: "toss-diagnostic", stage }, extra,
      }));
      return scope;
    });
  } catch { /* 진단 실패가 결제 흐름을 중단하지 않도록 한다. */ }
}
